import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  title: 'PPPOS',
  navTheme: 'light',
  colorPrimary: '#FF6B35',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  pwa: true,
  logo: '/icons/favicon.png',
  token: {},
  footerRender: false,
};

export default Settings;
